import {createContext} from "react";

import {ServiceTag} from "@/lib/types/checks.ts";

export const TagsContext = createContext<Record<number, ServiceTag>>({});
